module.exports = __webpack_public_path__ + "img/record.75456bb3.png";